import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
import { ScrollSmoother } from "gsap/ScrollSmoother";

import { useGSAP } from '@gsap/react';

import { pageInitState } from "../utils/config";
import { scrollResizeControlMake, smoother } from '../utils/scroll-resize';

function Web ({appLoaded, loadingOn, pageChangeOn, setPageChangeOn, pageOn, setPageOn, setCursorOn}) {
  useGSAP((context, contextSafe) => {
    console.log(`Web: useGSAP:[appLoaded(${appLoaded}), loadingOn(${loadingOn}), pageChangeOn.web(${pageChangeOn.web}), pageOn.web(${pageOn.web})]`);
    let timeoutId;

    if(appLoaded && !loadingOn) {

      if(pageChangeOn.web) {
        timeoutId = setTimeout(() => {
          console.log('Web: useGSAP: setTimeout: setPageChangeOn');

          scrollResizeControlMake(gsap, ScrollTrigger, Observer, ScrollSmoother, 'web');
          smoother.scrollTop(0);
          smoother.paused(true);

          setPageChangeOn({...pageInitState});
          setPageOn({...pageInitState, web: true});
        }, 1500);
      } else if (pageOn.web) {
        smoother.paused(false);
      }

    }

  
    return () => {
      console.log(`Web: useGSAP:[appLoaded(${appLoaded}), loadingOn(${loadingOn}), pageChangeOn.web(${pageChangeOn.web}), pageOn.web(${pageOn.web})]: cleanup`);

      if(appLoaded && !loadingOn) {
        clearTimeout(timeoutId);
      }

      // ScrollTrigger.getAll().forEach(t => t.kill());
      // if(ScrollSmoother.get()) ScrollSmoother.get().kill();
    }
  }, {dependencies: [appLoaded, loadingOn, pageChangeOn.web]});

  return (
    <div className="part page page-web">
      <div className='part-in'>
          <section className="sector sector-h-full hero">
            <div className="container container-w-full xcontainer-w-cap container-w-no-gutter-out">
              <div className="container-in">
                <div className='contents-wrapper'> 
                  <h1> WEB </h1>
                </div>
              </div>
            </div>
          </section>
          <section className="sector sector-h-full sub">
            <div className="container container-w-full xcontainer-w-cap container-w-no-gutter-out">
              <div className="container-in">
                <div className='contents-wrapper'> 
                  <h1> WEB </h1>
                </div>
              </div>
            </div>
          </section>
      </div>
    </div>  
  ); 
}

export default Web;